import { DELETE_TOKEN } from '../../mutation-types';
import { login, logoff } from '../../../services/auth-service';
import { stopTimeWorker } from '@/workers';

const actions = {
  auth({ commit }, user) {
    commit(DELETE_TOKEN);
    return new Promise((resolve, reject) => {
      login(user)
        .then((response) => {
          resolve({
            response,
            user,
          });
        })
        .catch((err) => {
          reject(err.response);
        });
    });
  },

  logoff({ dispatch }) {
    return new Promise((resolve, reject) => {
      logoff()
        .then(() => {
          stopTimeWorker();
          dispatch('attendance/disconnectClient', null, {
            root: true,
          });
          dispatch('deleteToken');
          dispatch('resetState', null, { root: true });
          resolve(true);
        })
        .catch(reject);
    });
  },

  deleteToken({ commit }) {
    commit(DELETE_TOKEN);
  },
};

export default actions;
